var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticStyle:{"background":"white","padding":"0"}},[_c('layout-header',{on:{"publish":_vm.validateDesign}})],1),_c('div',{staticClass:"layout-body"},[_c('router-view',{on:{"publish":_vm.validateDesign}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }